import React, { useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useContactData, useSiteSettings, useAboutData } from '../lib/cmsStore';
import { GameSection } from './GameSection';
import { ContactModal } from './ContactModal';
export function ContactSection() {
  const ref = useRef(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [showContactModal, setShowContactModal] = useState(false);
  const {
    data,
    isLoading
  } = useContactData();
  const {
    data: siteData,
    isLoading: siteLoading
  } = useSiteSettings();
  const {
    data: aboutData,
    isLoading: aboutLoading
  } = useAboutData();
  // Use contact page email first, fall back to global settings email
  const contactEmail = !isLoading && data?.email ? data.email : '';
  const settingsEmail = !siteLoading && siteData?.contactEmail ? siteData.contactEmail : '';
  const email = contactEmail || settingsEmail || 'your@email.com';
  // Social links from About page (same source as hero section)
  const socialLinks = !aboutLoading && aboutData?.socialLinks ? aboutData.socialLinks.filter(link => link.visible) : [{
    platform: 'GITHUB',
    url: '#'
  }, {
    platform: 'LINKEDIN',
    url: '#'
  }, {
    platform: 'TWITTER',
    url: '#'
  }];
  const showGame = siteData?.sectionVisibility?.game !== false;
  return <section id="contact" className="py-24 md:py-40 px-6 md:px-12 border-t border-border" data-id="element-111">
      <div ref={ref} className="max-w-6xl mx-auto" data-id="element-112">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-113">
          <span className="font-mono text-xs text-primary uppercase tracking-widest" data-id="element-114">
            // Contact
          </span>

          <h2 className="font-display text-5xl md:text-8xl font-bold tracking-tighter mt-4 cursor-pointer group" onClick={() => setShowContactModal(true)} data-id="element-115">
            {(() => {
            const title = !isLoading && data?.pageTitle ? data.pageTitle : "Let's work together";
            const words = title.split(' ');
            if (words.length <= 2) return <span className="text-gradient group-hover:opacity-80 transition-opacity" data-id="element-116">
                    {title}
                  </span>;
            const lastWord = words.pop();
            return <>
                  {words.join(' ')}
                  <br data-id="element-117" />
                  <span className="text-gradient group-hover:opacity-80 transition-opacity" data-id="element-118">
                    {lastWord}
                  </span>
                </>;
          })()}
          </h2>

          <div className="mt-16 grid md:grid-cols-2 gap-12" data-id="element-119">
            <div className="space-y-6" data-id="element-120">
              <button onClick={() => setShowContactModal(true)} className="block font-display text-xl md:text-2xl font-bold hover:text-primary transition-colors text-left" data-id="element-121">
                Message me →
              </button>
              <div className="flex flex-wrap gap-6" data-id="element-122">
                {socialLinks.map(link => <a key={link.platform} href={link.url} className="font-mono text-xs uppercase tracking-widest text-muted-foreground hover:text-primary transition-colors border-b border-transparent hover:border-primary pb-1" data-id="element-123">
                    {link.platform}
                  </a>)}
              </div>
            </div>
          </div>
        </motion.div>

        {/* Game — between contact content and footer */}
        {showGame && <GameSection data-id="element-124" />}
      </div>

      {/* Footer */}
      <div className="max-w-6xl mx-auto mt-24 pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-125">
        <span className="font-mono text-xs text-muted-foreground" data-id="element-126">
          {siteData?.footerText || `© ${new Date().getFullYear()} Sinka. All rights reserved.`}
        </span>
      </div>

      {showContactModal && <ContactModal onClose={() => setShowContactModal(false)} data-id="element-127" />}
    </section>;
}